import React, { useState, useEffect } from "react";
import "./Contact.scss";
import Axios from "axios";
const Contact = () => {
  const [data, setData] = useState({
    email: "",
    message: "",
  });
  const [submit, setSubmit] = useState(false);
  const [words, setWords] = useState(0);
  const [vaildation, setValidate] = useState("");
  const changeHandler = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const { email, message } = data;
  useEffect(() => {
    // console.log(message);
    if (message === "") {
      setWords(0);
    } else {
      setWords(message.trim().split(" ").length);
    }
  }, [message]);
  function validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  const submitHandler = async (e) => {
    e.preventDefault();
    if (validateEmail(email)) {
      try {
        const { data } = await Axios.post(process.env.REACT_APP_CONTACT_API, {
          email,
          message,
        });
        if (data.message) {
          setSubmit(true);
        }
        console.log(data);
      } catch (err) {
        setValidate("An Error Occurred");
        // console.log(err);
      }
    } else {
      setValidate("Invalid email");
      // console.log("error invalid email");
    }
  };
  return (
    <div className="conatct container" id="contact">
      <div className="">
        <h6 className="heading  my-5">Contact</h6>
        <div className="container p-5 pt-3 mb-5 card card-shadow">
          {submit ? (
            <div>
              <h5 className="text-success text-center">
                Thanks For Your Response
              </h5>
            </div>
          ) : (
            <form>
              <div className="form-group">
                <label>Email address</label>
                <input
                  type="email"
                  className="form-control"
                  id="exampleFormControlInput1"
                  placeholder="name@example.com"
                  name="email"
                  value={email}
                  onChange={changeHandler}
                  required
                />
              </div>
              <div className="form-group">
                <label>Message</label>
                <textarea
                  className="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                  name="message"
                  value={message}
                  onChange={changeHandler}
                ></textarea>
              </div>
              <div className="btn-div">
                <div className="validate-text">
                  <p className="text-danger">{vaildation}</p>
                  <p>{words} Words</p>
                </div>
                <button className="btn btn-primary" onClick={submitHandler}>
                  Submit
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default Contact;
